import { render } from "./SwdSideClientAdvisorBar.vue?vue&type=template&id=3b9a2b69&scoped=true"
import script from "./SwdSideClientAdvisorBar.vue?vue&type=script&lang=js"
export * from "./SwdSideClientAdvisorBar.vue?vue&type=script&lang=js"

import "./SwdSideClientAdvisorBar.vue?vue&type=style&index=0&id=3b9a2b69&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9a2b69"]])

export default __exports__